import React from 'react';

const EmptyRowsView = () => {
  return <div />;
};

const getRowsCount = (value, props, readOnly) => {
  let rows = 0;
  if (value) {
    rows = value.length;
  }
  if (props.custom && props.custom.addBlankRow && !readOnly) rows++;
  return rows;
};

function getContentWidth(props) {
  const { custom } = props;
  if (custom.autoWidth) {
    //If autoWidth is set, we just leave EditableDataGrid/ReactDataGrid to figure it out themselves.
    return undefined;
  } else if (custom.contentWidth) {
    return custom.contentWidth;
  }
  let menuAdj = custom.appMenuHidden ? 0 : 206;
  if (!custom.appSidebarHidden) {
    menuAdj += 300;
  }
  const lookupAdj = custom.lookupView ? window.innerWidth * 0.2 - menuAdj - 60 : 0;
  return custom.pageView ? window.innerWidth * 0.85 - 30 : window.innerWidth - 76 - menuAdj - lookupAdj;
}

const processProps = (type, props, _value, readOnly) => {
  const { value, component, onChange } = props;
  if (component.displayName === 'EditableDataGrid') {
    const rowsCount = getRowsCount(value, props, readOnly);
    const contentWidth = getContentWidth(props);
    return {
      ...props,
      rowsCount: rowsCount,
      listData: value || [],
      enableContextMenu: props.enableContextMenu || false,
      emptyRowsView: EmptyRowsView,
      onRowUpdated: onChange,
      contentWidth: contentWidth,
    };
  }
  if (component.displayName === 'Workspace') {
    return {
      hideColumnSelector: true,
      hideViewController: true,
      ...props,
      onRowUpdated: onChange,
      embeddedView: true,
    };
  }
  return props;
};

const createFieldProps = (
  getIn,
  dataid,
  {
    onBlur,
    onChange,
    dispatch,
    dirty,
    meta,
    onFocus,
    format,
    component,
    connectedForm,
    pristine,
    props,
    state,
    value,
    testId,
    _value,
    readOnly: readOnlyProp,
    forceReadOnly,
    datacomponent = '',
    ...custom
  }
) => {
  const validationRules = meta && getIn(meta, 'validationRules');
  const objectType = meta && getIn(meta, 'objectType');

  const formatFieldValue = (value, format, custom) => {
    if (format === null) {
      return value;
    }
    return format ? format(value, name, custom) : value;
  };
  const formattedFieldValue = formatFieldValue(value, format, custom);
  let readOnly;
  //If forceReadOnly is defined, it overrides any other options. (Including setting readOnly to false).
  if (forceReadOnly !== undefined) {
    readOnly = forceReadOnly;
  } else {
    readOnly = connectedForm.readOnly || getIn(connectedForm, 'location.state.readOnly') || readOnlyProp || custom.busy;
  }
  const testtag = testId ? testId : dataid;
  const id = `${datacomponent}${dataid}`;
  return {
    input: processProps(
      custom.type,
      {
        dataid,
        onBlur,
        onChange,
        onFocus,
        value: formattedFieldValue,
        component,
        custom,
      },
      _value,
      readOnly
    ),
    meta: {
      ...state,
      active: !!(state && getIn(state, 'active')),
      connectedForm,
      dirty,
      dispatch,
      hint: validationRules && getIn(validationRules, 'hint'),
      mandatory: validationRules && getIn(validationRules, 'mandatory'),
      minLength: validationRules && getIn(validationRules, 'minLength'),
      maxLength: validationRules && getIn(validationRules, 'maxLength'),
      objectType,
      pattern: validationRules && getIn(validationRules, 'pattern'),
      patternMessage: validationRules && getIn(validationRules, 'patternMessage'),
      pristine,
      testId: testtag,
      touched: !!(state && getIn(state, 'touched')),
      type: meta && getIn(meta, 'type'),
      visited: !!(state && getIn(state, 'visited')),
      readOnly,
      tabIndex: 0,
      id: id,
    },
    custom: { ...custom, ...props },
  };
};

export default createFieldProps;
